import { useUX } from '@/ux'
import { translations } from './translations'

type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? `${Key}` | `${Key}.${NestedKeyOf<ObjectType[Key]>}`
    : `${Key}`
}[keyof ObjectType & (string | number)]

type TranslationKeys = NestedKeyOf<typeof translations.en>

function get(obj: Record<string, unknown>, path: string): string {
  const keys = path.split('.')
  let result: unknown = obj

  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = (result as Record<string, unknown>)[key]
    } else {
      return path // Fallback to key if not found
    }
  }

  return typeof result === 'string' ? result : path
}

function interpolate(text: string, vars?: Record<string, unknown>): string {
  if (!vars) return text

  return text.replace(/\{(\w+)\}/g, (_, key) => {
    const value = vars[key]
    return value !== undefined && value !== null ? String(value) : `{${key}}`
  })
}

export function useTranslation() {
  const { locale } = useUX()

  const t = (key: TranslationKeys, vars?: Record<string, unknown>): string => {
    const text = get(translations[locale] as Record<string, unknown>, key)
    return interpolate(text, vars)
  }

  return { t, locale }
}
